import React from 'react';
import { usePermissionContext } from './permission-provider';
import { useAccountStore, useAuthStore } from 'store';
import { AccountType } from 'dto/access-management/account-dto';

const useRaptorArtifactPermissionContext = () => {
    const { hasPermission, runHandler } = usePermissionContext();
    const accountStore = useAccountStore();
    const { currentUser } = useAuthStore();
    const { canModify, canModifyArtifact } = React.useMemo(() => {
        const canModify = hasPermission('Upload Files Modify');
        return {
            canModify,
            canModifyArtifact: <T extends { accountUuid: string }>(artifact: T) => {
                if (!canModify) {
                    return false;
                }
                // DPU users can modify any artifact. Otherwise, check if the user has access to the account where the artifact was uploaded.
                if (currentUser.accountType === AccountType.DPU) {
                    return true;
                }
                return !!accountStore.getAccountByUuid(artifact.accountUuid);
            },
        };
    }, [hasPermission, accountStore.displayAccounts]);

    return {
        hasPermission,
        canModify,
        canModifyArtifact,
        runHandler,
    };
};
export { useRaptorArtifactPermissionContext };
